import { GLServiceBase, ServiceRoute } from "commonui";
import { IWordSpecsReportManager } from "./interface";
import { WordSpecsReportResponseModel, WordSpecsReportRequestParamsModel } from "./model";

class WordSpecsReportServiceClass extends GLServiceBase<any, any> implements IWordSpecsReportManager {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsReports" };

	getWordSpecsReport(params: WordSpecsReportRequestParamsModel): Promise<WordSpecsReportResponseModel[]> {
		return this.get("wordSpecReport", params);
	}
}

export const WordSpecsReportManagerService = () => new WordSpecsReportServiceClass();
